if (!customElements.get('highlighted-collections')) {
  class HighlightedCollections extends HTMLElement {
    constructor() {
      super();

      // Init når sektionen reloades i theme editor
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.contains(this)) this.init();
        });
      }

      // Init kun på desktop (samme som før)
      if (window.innerWidth >= 990) {
        this.init();
      }
    }

    init() {
      this.displayImages();
    }

    displayImages() {
      const collectionItems = this.querySelectorAll('.highlighted__collections-item-box');
      const collectionImages = this.querySelectorAll('.highlighted__collections-image');

      if (!collectionItems.length || !collectionImages.length) return;

      // Funktion der aktiverer det rigtige billede
      const activateImage = (targetId) => {
        collectionItems.forEach(item => item.classList.remove('highlighted__collections-active'));
        collectionImages.forEach(img => img.classList.remove('highlighted-img--active'));

        const activeItem = this.querySelector(`[data-image="${targetId}"]`);
        const activeImage = this.querySelector(`[data-hover="image-${targetId}"]`);

        if (activeItem) activeItem.classList.add('highlighted__collections-active');
        if (activeImage) activeImage.classList.add('highlighted-img--active');
      };

      // Default: sørg for første billede er aktivt
      const firstItem = collectionItems[0];
      if (firstItem) {
        const id = firstItem.getAttribute('data-image');
        activateImage(id);
      }

      // Hover-effekt (desktop)
      collectionItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          const dataImageValue = item.getAttribute('data-image');
          activateImage(dataImageValue);
        });
      });

      // Klik/tap-effekt (mobil)
      collectionItems.forEach((item) => {
        item.addEventListener('click', () => {
          const dataImageValue = item.getAttribute('data-image');
          activateImage(dataImageValue);
        });
      });
    }
  }

  customElements.define('highlighted-collections', HighlightedCollections);
}
